import { Injectable } from '@angular/core';
import { RuntimeErrorHandler } from '../models/runtime-error.handler';

@Injectable({ providedIn: 'root' })
export class DefaultRuntimeErrorHandler extends RuntimeErrorHandler {
  handle(error: Error): void {
    console.error('Runtime error:', error);
  }
}
